/**
 * RoleGate — blokada routingu wg roli (2026-05-20).
 *
 * Użycie:
 *   <RoleGate blockRoles={['handlowiec', 'viewer']}>
 *     <SomeAdminPage />
 *   </RoleGate>
 *
 * Jeśli rola usera (z localStorage.user.role) jest w blockRoles →
 * redirect do `redirectTo` (default: /home-v3).
 *
 * Defensywne: gdy brak usera/roli → traktujemy jako viewer.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';

function getUserRole() {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    return u.role || 'viewer';
  } catch {
    return 'viewer';
  }
}

export default function RoleGate({ blockRoles, redirectTo = '/home-v3', children }) {
  const role = getUserRole();
  if (Array.isArray(blockRoles) && blockRoles.includes(role)) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}

// Helper: spójna blokada dla handlowca w wielu routach
export const blockForHandlowiec = (element) => (
  <RoleGate blockRoles={['handlowiec']}>{element}</RoleGate>
);
